import React from "react";
import warning from "../assets/svg/little-warning.svg";
import Image from "@vfuk/core-image";
import { t } from "i18next";

const DIMENSION = "20px";

export const LittleWarning = () => {
  return (
    <Image
      alt={t("core:common:warning")}
      sm={{
        src: warning,
        width: DIMENSION,
        height: DIMENSION,
      }}
    />
  );
};
